import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet-routing-machine";

interface RoutingProps {
  userLocation: { lat: number; lon: number };
  targetLocation: { lat: number; lon: number };
}

export default function MapRouting({ userLocation, targetLocation }: RoutingProps) {
  const map = useMap();
  const routingControlRef = useRef<any>(null);

  useEffect(() => {
    if (!map) return;

    // Create the control
    const routingControl = (L as any).Routing.control({
      waypoints: [
        L.latLng(userLocation.lat, userLocation.lon),
        L.latLng(targetLocation.lat, targetLocation.lon),
      ],
      lineOptions: {
        styles: [{ color: "#007bff", weight: 5 }]
      },
      addWaypoints: false,
      draggableWaypoints: false,
      fitSelectedRoutes: true,
      show: false, // Hides the side panel instructions
    }).addTo(map);

    routingControlRef.current = routingControl;

    // CLEANUP: This is where the error is fixed
    return () => {
      if (routingControlRef.current && map) {
        try {
          // Manually hide/clear lines before removing to prevent the "removeLayer" error
          routingControlRef.current.setWaypoints([]); 
          map.removeControl(routingControlRef.current);
        } catch (e) {
        //   console.warn("Routing cleanup handled:", e);
        }
      }
    };
  }, [map, userLocation, targetLocation]);

  return null;
}